<template>
    <div id="inner">
        <b-row>
            <b-col>
                <p>
                    Hier vindt u uw reactie(s) op geadverteerde woningen die inmiddels toegewezen zijn.
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <div v-if="!finished" class="text-center">
                    <br/>
                    <h1>Bezig met laden...</h1>
                </div>
                <div v-else-if="adverts.length === 0" class="text-center">
                    <br/>
                    <h1>Nog geen advertenties</h1>
                </div>
                <div v-else class="archive" v-for="advert in adverts" :key="advert.advert">
                    <hr/>
                    <house-blurb
                            :advert="advert"
                            :showLetters="true"
                            :withdrawType="'none'"
                            :showRemainingTime="false"
                    >
                    </house-blurb>
                </div>
            </b-col>
            <b-row v-if="!hasLoadedMore">
                <b-col>
                    <b-button variant="success" @click="loadRest">Meer...</b-button>
                </b-col>
            </b-row>
        </b-row>
    </div>
</template>

<script>
    import houseBlurb from '@/components/_reaction/houseBlurb'

    export default {
        components: { houseBlurb },
        props: [
            'adverts',
            'finished'
        ],
        data: () => {
            return {
                hasLoadedMore: false
            }
        },
        name: 'offerArchive',
        methods: {
            loadRest() {
                this.hasLoadedMore = true
                this.$emit('loadRest',{})
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .item-icon {
        width: 100px;
    }
</style>
